<template>
  <div>
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        :z-index="10000000"
        background-color="#000"
        color="#fff"
      ></loading>
    </div>
    <div class="contentArea">
      <!-- <p>{{ paidList }}</p>
      <p>{{ selectedInvoice }}</p>
      <p>{{ invoiceList }}</p> -->
      <!-- <p>folder: {{ folderId }}</p> -->
      <!-- <p>{{ fileList }}</p> -->
      <!-- <p>{{ deleteFileList }}</p> -->
      <base-dialog :show="successModal" small>
        <div class="success my-10">
          <img src="../assets/success.svg" alt="" />
          <h2 class="mt-10 text-white">แก้ไขสำเร็จ</h2>
        </div>
      </base-dialog>
      <form @submit.prevent="submitForm">
        <div class="card">
          <div class="grid grid-cols-2 gap-x-12 partition">
            <div class="grid grid-cols-5 gap-y-4 items-baseline box">
              <h4>ผู้รับเงิน</h4>
              <select
                class="col-span-4"
                v-model="selectedAccoutingId"
                @change="setCurrentAccount"
                disabled
              >
                <option
                  v-for="account in accountingList"
                  :key="account.accounting_id"
                  :value="account.accounting_id"
                  >{{ account.acc_code }}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {{ account.name_th }}
                </option>
              </select>
              <p class="">ที่อยู่</p>
              <textarea
                rows="3"
                class="col-span-4"
                :value="currentAccouting ? currentAccoutingAddress : ''"
                disabled
              />
              <p>Tax ID</p>
              <input
                type="text"
                class="col-span-4"
                :value="currentAccouting ? currentAccouting.tax_id : ''"
                disabled
              />
            </div>
            <div class="grid grid-cols-5 grid-rows-3 items-baseline box">
              <h4>บัญชีที่รับเงิน</h4>
              <select
                class="col-span-4"
                v-model="selectedAccountName"
                @change="setCurrentBankPaymentName()"
              >
                <option
                  v-for="bank in accountNameList"
                  :key="bank"
                  :value="bank"
                >
                  {{ bank }}</option
                >
              </select>
              <p class="">ธนาคาร</p>
              <select class="col-span-4" v-model="currentBank" required>
                <option
                  v-for="bank in currentBankList"
                  :key="bank.bankpayment_id"
                  :value="{
                    bankpayment_id: bank.bankpayment_id,
                    bank: bank.bank,
                    acc_number: bank.acc_number,
                  }"
                >
                  {{
                    bank.bank
                  }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                    bank.acc_number
                  }}
                </option>
              </select>
              <!-- <p>เลขบัญชี</p>
              <input
                type="text"
                class="col-span-4"
                :value="currentBank ? currentBank.acc_number : ''"
                disabled
              /> -->
            </div>
          </div>
          <div class="grid grid-cols-2 gap-x-12 partition">
            <div class="grid grid-cols-5 gap-y-4 items-baseline box">
              <p>ชื่อลูกค้า :</p>
              <input
                type="text"
                class="col-span-4"
                :value="currentMember ? currentMember.company_name : ''"
                disabled
              />
              <p class="">รายละเอียด :</p>
              <textarea
                rows="3"
                class="col-span-4"
                :value="currentMember ? currentMemberAddress : ''"
                disabled
              />
              <p>Tax ID :</p>
              <input
                type="text"
                class="col-span-4"
                :value="currentMember ? currentMember.tax_id : ''"
                disabled
              />
            </div>
            <div
              class="grid grid-cols-5 gap-y-4 auto-rows-min items-center box"
            >
              <p>วันที่ออก :</p>
              <div class="col-span-4">
                <v-date-picker
                  class="date-picker w-full"
                  is-dark
                  v-model="createDate"
                  is-required
                >
                  <template v-slot="{ inputEvents }">
                    <div class="date w-full">
                      <input
                        type="button"
                        class="date-input w-full text-left"
                        v-on="inputEvents"
                        :value="formattedCreateDate"
                        disabled
                      />
                    </div>
                  </template>
                </v-date-picker>
              </div>
            </div>
          </div>
          <div
            :class="{ partition: !(invoiceList.length - 1 === index) }"
            v-for="(invoice, index) in invoiceList"
            :key="index"
          >
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <div class="task-no mr-10">
                  <h3 class="text-white">No.{{ index + 1 }}</h3>
                </div>
                <h3 class="text-white font-normal">
                  ใบแจ้งหนี้ เลขที่ {{ invoice.invoice_code }}
                </h3>
              </div>
            </div>
            <div class="grid grid-cols-12 text-white table-header">
              <div class="col-span-1 grid grid-cols-2 justify-items-center">
                <!-- <div>
                  <vs-checkbox
                    color="#57c293"
                    :value="allSetPaid(index)"
                    :disabled="allPaid(index)"
                  ></vs-checkbox>
                </div> -->
                <p>ลำดับ</p>
              </div>
              <div class="col-span-7">
                <p>รายละเอียด</p>
              </div>
              <div class="col-span-2">
                <p>ภาษีหัก ณ ที่จ่าย</p>
              </div>
              <div class="col-span-1">
                <p>ราคา (บาท)</p>
              </div>
            </div>
            <div class="table-info">
              <div
                class="grid grid-cols-12 text-white items-center table-item"
                v-for="(task, subidx) in invoice.task"
                :key="subidx"
              >
                <div class="col-span-1 grid grid-cols-2  justify-items-center">
                  <!-- <div>
                    <vs-checkbox
                      v-if="task.task.isPaid"
                      color="#57c293"
                      :value="true"
                      disabled
                    ></vs-checkbox>
                    <vs-checkbox
                      v-else
                      color="#57c293"
                      v-model="paidList[index].paid[subidx].value"
                    ></vs-checkbox>
                  </div> -->
                  <p>{{ subidx + 1 }}</p>
                </div>
                <div class="col-span-7">
                  <p>
                    {{ task.task.task_name }}
                    {{ taskDateFormat(task.task.task_name, task.task.date) }}
                  </p>
                </div>
                <div class="col-span-1 text-center">
                  <p>{{ task.task.tax ? task.task.tax + "%" : "-" }}</p>
                </div>
                <div class="col-start-11 col-span-2">
                  <p>{{ numberComma(task.task.price.toFixed(2)) }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center mb-10">
            <p>หมายเหตุ : ภาษีมูลค่าเพิ่มชำระเกินสะสม</p>
            <!-- <input
              class="ml-3 mr-3"
              style="width: 100px"
              v-model.number="noteTax"
              type="number"
              step="0.01"
            /> -->
            <vue-numeric
              class="ml-3 mr-3 input-box"
              separator=","
              precision="2"
              v-model.number="noteTax"
            >
            </vue-numeric>
            <p>บาท รอนำไปหักภาษีขายเดือนถัดไป</p>
          </div>
          <div class="grid grid-cols-2 gap-x-10 grid-rows-2">
            <div class="grid grid-cols-5">
              <p>หมายเหตุ :</p>
              <textarea
                class="w-full col-span-4"
                rows="10"
                placeholder="หมายเหตุ"
                v-model="note"
              ></textarea>
            </div>
            <div class="grid grid-cols-2 gap-y-2 row-span-2 auto-rows-min">
              <div class="col-span-2">
                <div class="grid grid-cols-12">
                  <p class="col-span-3">วิธีการชำระเงิน</p>
                  <select class="col-span-9" v-model="payMethod">
                    <option value="โอนเงิน">โอนเงิน</option>
                    <option value="เช็ค">เช็ค</option>
                  </select>
                </div>
              </div>
              <div class="col-span-2">
                <div v-if="payMethod === 'เช็ค'" class="grid grid-cols-12">
                  <p class="col-span-3">ธนาคาร</p>
                  <select class="col-span-9" v-model="chequeBank" required>
                    <option
                      v-for="name in bankNameList"
                      :key="name"
                      :value="name"
                    >
                      {{ name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-span-2">
                <div v-if="payMethod === 'เช็ค'" class="grid grid-cols-12">
                  <p class="col-span-3">เลขที่เช็ค</p>
                  <input
                    class="col-span-9 text-left"
                    type="text"
                    v-model="chequeNumber"
                    required
                  />
                </div>
              </div>
              <div v-if="payMethod === 'เช็ค'" class="col-span-2">
                <div class="grid grid-cols-12">
                  <p class="col-span-3">วันที่</p>
                  <div class="col-span-9">
                    <v-date-picker
                      class="date-picker w-full"
                      is-dark
                      v-model="chequeDate"
                      is-required
                    >
                      <template v-slot="{ inputEvents }">
                        <div class="date w-full">
                          <input
                            type="button"
                            class="date-input w-full text-left"
                            v-on="inputEvents"
                            :value="formattedChequeDate"
                          />
                        </div>
                      </template>
                    </v-date-picker>
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-2 col-span-2 summary items-baseline">
                <p class="my-2">จำนวนเงินรวม</p>
                <p class="text-right">{{ totalPrice }}</p>
                <p class="my-2">ภาษีหัก ณ ที่จ่าย</p>
                <p class="text-right">{{ totalTax }}</p>
                <p class="my-2">ยอดสุทธิ</p>
                <p class="text-right">{{ totalNet }}</p>
                <div
                  style="border-bottom: 1px solid #ffffff"
                  class="col-span-2"
                ></div>
                <p class="my-6">ชำระมาแล้ว</p>
                <!-- <input
                  class="my-6"
                  type="number"
                  step="0.01"
                  id="summary-input"
                  v-model.number="amount"
                /> -->
                <vue-numeric
                  class="my-6"
                  id="summary-input"
                  style="height: 34px;"
                  separator=","
                  precision="2"
                  v-model.number="amount"
                >
                </vue-numeric>
                <div
                  style="border-bottom: 1px solid #ffffff"
                  class="col-span-2"
                ></div>
                <div>
                  <p class="mt-4">ผลต่าง</p>
                  <select id="summary-select" v-model="difference">
                    <option value="ค่าธรรมเนียมธนาคาร"
                      >ค่าธรรมเนียมธนาคาร</option
                    >
                    <option value="เงินขาด/เงินเกิน">เงินขาด/เงินเกิน</option>
                  </select>
                </div>
                <input
                  class="self-center mt-8 text-white"
                  type="number"
                  id="summary-input"
                  v-model.number="differenceValue"
                  disabled
                />
              </div>
              <div class="grid grid-cols-2 col-span-2 mt-2">
                <vs-checkbox
                  v-model="useAuthorize"
                  color="#15c1c3"
                  :disabled="
                    currentAccouting ? !currentAccouting.authorize : false
                  "
                  ><p>
                    ผู้อนุมัติ:
                    {{ currentAccouting ? currentAccouting.authorize : "" }}
                  </p></vs-checkbox
                >
              </div>
            </div>
          </div>
          <div
            v-if="folderId"
            class="grid md:grid-cols-8 xl:grid-cols-12  mt-8 justify-items-center"
          >
            <div
              v-for="(file, index) in fileList"
              :key="index"
              class="grid file-box text-center items-center"
            >
              <font-awesome-icon
                icon="times-circle"
                :style="{ color: '#ff4a3d' }"
                class="cross"
                @click="setDeleteFile(index)"
              />
              <div>
                <font-awesome-icon
                  class="mb-2"
                  icon="file-alt"
                  :style="{ color: '#ffffff' }"
                  size="3x"
                />
                <p class="file-name ml-1">{{ file.name }}</p>
              </div>
            </div>
            <div class="grid add-file text-center items-center">
              <label for="file">
                <font-awesome-icon
                  class="mb-2"
                  icon="file-upload"
                  :style="{ color: '#ffffff' }"
                  size="3x"
                />
                <p>เพิ่มเอกสาร</p>
              </label>
            </div>
            <input
              type="file"
              name="image"
              id="file"
              style="display: none"
              ref="fileInput"
              @change="onSelectFile($event)"
            />
          </div>
        </div>
        <div class="grid grid-cols-10 gap-4">
          <vs-button
            class="col-end-10 mt-5 mb-8"
            color="#ffffff"
            text-color="#8d9498"
            @click="goBackPage"
            >ยกเลิก</vs-button
          >
          <vs-button
            class="col-end-11 mt-5 mb-8"
            button="submit"
            color="#15c1c3"
            >บันทึก</vs-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import baseUrl from "../util/backend.js";
import fileUrl from "../util/backendfile";
import AgTable from "../views/elements/ag-grid-table/table_component/tableOnly";
import moment from "moment";
import VueNumeric from "vue-numeric";

export default {
  components: {
    AgTable,
    Loading,
    VueNumeric,
  },
  data() {
    return {
      isLoading: false,
      successModal: false,
      paidList: [],
      accountingList: [],
      bankPaymentList: [],
      memberList: [],
      modalCompany: null,
      currentAccouting: null,
      selectedAccountName: null,
      selectedAccoutingId: null,
      currentBankList: [],
      currentBank: null,
      currentMember: null,
      createDate: new Date(),
      noteTax: null,
      note: "",
      bankNameList: [
        "SCB",
        "BBL",
        "KBANK",
        "UOB",
        "BAY",
        "KTB",
        "TMB",
        "TBANK",
        "CIMB",
        "LH",
      ],
      payMethod: "โอนเงิน",
      chequeBank: null,
      chequeNumber: null,
      chequeDate: null,
      amount: 0,
      difference: "ค่าธรรมเนียมธนาคาร",
      differenceValue: 0,
      invoiceList: [],
      totalPrice: 0,
      totalTax: 0,
      totalNet: 0,
      useAuthorize: false,
      folderId: null,
      fileList: [],
      deleteFileList: [],
    };
  },
  watch: {
    // totalNet() {
    //   this.amount = this.totalNet.replace(/\,/g, "");
    // },
    // amount() {
    //   this.differenceValue = (
    //     this.amount - this.totalNet.replace(/\,/g, "")
    //   ).toFixed(2);
    // },
    amount() {
      this.differenceValue = (
        this.amount - this.totalNet.replace(/\,/g, "")
      ).toFixed(2);
    },
    accountingList() {
      this.setCurrentAccount();
    },
    payMethod() {
      if (this.payMethod === "โอนเงิน") {
        this.chequeNumber = null;
        this.chequeDate = null;
        this.chequeBank = null;
      }
    },
  },
  computed: {
    currentAccoutingAddress() {
      return this.currentAccouting.province === "กรุงเทพมหานคร"
        ? this.currentAccouting.address +
            " เขต" +
            this.currentAccouting.subdistrict +
            " แขวง" +
            this.currentAccouting.district +
            " " +
            this.currentAccouting.province +
            " " +
            this.currentAccouting.postcode
        : this.currentAccouting.address +
            " ต." +
            this.currentAccouting.subdistrict +
            " อ." +
            this.currentAccouting.district +
            " จ." +
            this.currentAccouting.province +
            " " +
            this.currentAccouting.postcode;
    },
    currentMemberAddress() {
      return this.currentMember.province === "กรุงเทพมหานคร"
        ? this.currentMember.address +
            " เขต" +
            this.currentMember.subdistrict +
            " แขวง" +
            this.currentMember.district +
            " " +
            this.currentMember.province +
            " " +
            this.currentMember.postcode
        : this.currentMember.address +
            " ต." +
            this.currentMember.subdistrict +
            " อ." +
            this.currentMember.district +
            " จ." +
            this.currentMember.province +
            " " +
            this.currentMember.postcode;
    },
    accountNameList() {
      const accountList = [];
      for (const account of this.bankPaymentList) {
        if (!accountList.includes(account.acc_name)) {
          accountList.push(account.acc_name);
        }
      }
      return accountList;
    },
    formattedCreateDate() {
      return moment(this.createDate).format("DD/MM/YYYY");
    },
    formattedChequeDate() {
      return this.chequeDate
        ? moment(this.chequeDate).format("DD/MM/YYYY")
        : null;
    },
  },
  methods: {
    numberComma(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    onSelectFile(e) {
      console.log(e.target.files[0]);
      console.log(e.target.value.split(/(\\|\/)/g).pop());
      this.fileList.push({
        name: e.target.value.split(/(\\|\/)/g).pop(),
        file: e.target.files[0],
      });
    },
    setDeleteFile(index) {
      if (this.fileList[index].file_id) {
        this.deleteFileList.push(this.fileList[index].file_id);
        this.fileList.splice(index, 1);
      } else {
        this.fileList.splice(index, 1);
      }
    },
    async submitForm() {
      this.isLoading = true;
      console.log({
        bankpayment_id: this.currentBank.bankpayment_id,
        note: this.note,
        note_tax: this.noteTax,
        date: this.createDate,
        payment_method: this.payMethod,
        cheque_number: this.chequeNumber,
        cheque_date: this.chequeDate
          ? moment(this.chequeDate).format("YYYY-MM-DD")
          : null,
        amount: this.amount,
        difference: this.difference,
        difference_value: this.differenceValue,
      });
      if (this.payMethod === "เช็ค" && !this.chequeDate) {
        alert("กรุณาเลือกวันที่รับเช็ค");
        return;
      }
      try {
        const res = await axios.post(
          `${baseUrl}/receipt/edit?receipt_id=${this.$route.params.id}`,
          {
            bankpayment_id: this.currentBank.bankpayment_id,
            note: this.note,
            note_tax: this.noteTax,
            date: this.createDate,
            payment_method: this.payMethod,
            cheque_bank: this.chequeBank,
            cheque_number: this.chequeNumber,
            cheque_date: this.chequeDate
              ? moment(this.chequeDate).format("YYYY-MM-DD")
              : null,
            amount: this.amount,
            difference: this.difference,
            difference_value: this.differenceValue,
            authorize: this.useAuthorize
              ? this.currentAccouting.authorize
              : null,
          },
          {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
          }
        );
        if (res.data.status === "success") {
          if (this.fileList) {
            for (const file of this.fileList) {
              if (!file.file_id) {
                let fileFormData = new FormData();
                fileFormData.append("file", file.file);
                fileFormData.append("folder_id", this.folderId);
                let fileRes = await axios.post(
                  `${fileUrl}/file/create`,
                  fileFormData
                );
                console.log("file response");
                console.log(fileRes);
                const fileId = fileRes.data.data.uploadFileAtLevel.file_id;
                const permissionRes = await axios.post(
                  `${baseUrl}/file/file/create`,
                  {
                    file_id: fileId,
                  },
                  {
                    headers: {
                      Authorization: this.$store.getters.getToken,
                    },
                  }
                );
                console.log(permissionRes);
              }
            }
          }
          for await (const delId of this.deleteFileList) {
            let delRes = await axios.post(
              `${baseUrl}/file/delete?file_id=${delId}`,
              {},
              {
                headers: {
                  Authorization: this.$store.getters.getToken,
                },
              }
            );
            console.log(delRes);
          }
          this.successModal = true;
          setTimeout(() => {
            this.successModal = false;
            this.$router.replace("/receipt");
          }, 1000);
        } else {
          const error = new Error("สร้างReceiptไม่สำเร็จ");
          throw error;
        }
      } catch (err) {
        alert(err);
      }
      this.isLoading = false;
    },
    async goBackPage() {
      this.$router.go(-1);
    },
    setCompany() {
      this.$store.dispatch("create/setCompanyName", this.modalCompany);
    },
    async setCurrentBankPaymentName() {
      this.currentBank = null;
      //   this.selectedAccountName = this.currentMember.bankpayment.acc_name;
      const getBank = await axios.get(
        `${baseUrl}/bankpayment/get/?acc_name=${this.selectedAccountName}`,
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      //   console.log(getBank);
      this.currentBankList = getBank.data.data;
    },
    async setCurrentAccount() {
      for await (const acc of this.accountingList) {
        if (acc.accounting_id === this.selectedAccoutingId) {
          this.currentAccouting = acc;
          break;
        }
      }
    },
    async loadData() {
      const accounting = await axios.get(`${baseUrl}/accounting/get`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      this.accountingList = accounting.data.data;
      const bankPayment = await axios.get(`${baseUrl}/bankpayment/get/`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      this.bankPaymentList = bankPayment.data.data;
      const member = await axios.get(`${baseUrl}/member/get`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      this.memberList = member.data.data;
      //   this.setCurrentMember();
      //   this.setCurrentAccount();
    },
    async loadReceipt() {
      this.isLoading = true;
      const res = await axios.get(
        `${baseUrl}/receipt/get?receipt_id=${this.$route.params.id}`,
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      this.folderId = res.data.folder_id;
      this.fileList = res.data.file;
      const receiptData = res.data.data;
      console.log("receiptData", receiptData);
      this.useAuthorize = receiptData.authorize ? true : false;
      // modal
      this.modalCompany = {
        name: receiptData.detail.company_name,
        id: receiptData.detail.detail_id,
      };
      this.setCompany();
      // ผู้รับเงิน
      this.selectedAccoutingId = receiptData.accounting_id;
      this.setCurrentAccount();
      // บัญชีและธนาคารที่รับเงิน
      this.selectedAccountName = receiptData.bankpayment.acc_name;
      this.setCurrentBankPaymentName();
      this.currentBank = {
        bankpayment_id: receiptData.bankpayment.bankpayment_id,
        bank: receiptData.bankpayment.bank,
        acc_number: receiptData.bankpayment.acc_number,
      };
      // ชื่อและรายละเอียด
      this.currentMember = receiptData.detail;
      this.createDate = receiptData.date;
      this.noteTax = receiptData.note_tax;
      this.note = receiptData.note;
      this.payMethod = receiptData.payment_method;
      this.chequeBank = receiptData.cheque_bank;
      this.chequeNumber = receiptData.cheque_number;
      this.chequeDate = receiptData.cheque_date;
      this.amount = receiptData.amount;
      this.totalPrice = this.numberComma(receiptData.price.toFixed(2));
      this.totalTax = this.numberComma(receiptData.tax.toFixed(2));
      this.totalNet = this.numberComma(receiptData.net.toFixed(2));
      this.differenceValue = receiptData.difference_value;
      // invoice ใน receipt
      this.invoiceList = receiptData.invoice;
      // this.setPaidList();
      this.isLoading = false;
    },
    taskDateFormat(name, date) {
      if (
        [
          "ค่าสอบบัญชี",
          "ค่าบริการงานบัญชีและปิดงบการเงินประจำปี",
          "ค่าบริการงานบัญชีประจำปี",
          "ค่าบริการจัดหาผู้สอบบัญชี",
        ].includes(name)
      ) {
        return `ปี ${moment(date).format("YYYY")}`;
      }
      if (
        [
          "ค่าบริการงานทะเบียน",
          "ค่าบริการจดทะเบียนบริษัท",
          "ค่าบริการคัดหนังสือรับรองและสำเนาเอกสาร",
          "ค่า Messenger",
        ].includes(name)
      ) {
        return "";
      }
      return `เดือน ${moment(date).format("MM/YYYY")}`;
    },
  },
  created() {
    this.$store.dispatch("create/setSelectedInvoice", []);
    this.loadData();
    this.loadReceipt();
  },
  updated() {
    this.setCurrentAccount();
  },
};
</script>

<style scoped>
p {
  color: #ffffff;
}

h2,
h4 {
  color: #dddddd;
}

h4 {
  font-size: 18px;
}

input[type="number"],
input[type="text"],
input[type="button"],
select,
textarea {
  border-radius: 2px;
  background: #3a3f51;
  border: none;
  color: #ffffff;
  font-size: 17px;
  padding-left: 10px;
}

textarea {
  padding-top: 5px;
}

select,
input[type="number"],
input[type="button"],
input[type="text"] {
  height: 34px;
  min-width: 0;
}

input[type="number"] {
  text-align: right;
}

input[type="text"]:disabled,
input[type="button"]:disabled,
input[type="number"]:disabled,
textarea:disabled {
  color: #999da6;
  background-color: #404455;
}

.card {
  background-color: #4e5363;
  border-radius: 5px;
  padding: 10px 35px;
}

.box {
  padding: 27px;
  border: 1px solid #3a3f51;
  border-radius: 5px;
}

.partition {
  padding-bottom: 30px;
  margin-bottom: 40px;
  border-bottom: 1px solid #3e3e41;
}

.task-table {
  border: 1px solid #3e3e41;
  border-radius: 5px;
}

.table-header {
  border: 1px solid #3a3f51;
  border-radius: 5px 5px 0 0;
  background-color: #3a3f51;
  padding: 10px;
}

.table-info {
  border: 1px solid #3a3f51;
  border-radius: 0 0 5px 5px;
  background-color: #4e5363;
  padding: 0 10px 10px 10px;
  margin-bottom: 20px;
}

.table-item {
  padding: 10px 0;
  border-bottom: 1px solid #3a3f51;
}

.bin-icon {
  text-align: center;
  width: 22px;
  height: 22px;
  border-radius: 7px;
  border: solid 1px #ff4a3d;
  cursor: pointer;
}

.summary {
  background-color: #3a3f51;
  border-radius: 5px;
  padding: 20px 26px;
}

#summary-input {
  text-align: right;
  border: 0.5px solid #ffffff;
  color: #ffffff;
  background: #3a3f51;
  padding: 0 10px;
}

#summary-select {
  background-color: #ededed;
  color: #3a3f51;
  width: 80%;
}

.modal-select {
  background-color: #4e5363;
}

.success {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.task-no {
  background-color: #5f51f9;
  text-align: center;
  border-radius: 5px;
  padding: 5px 15px;
  margin: 10px 0px;
}

label {
  cursor: pointer;
}

.add-file {
  position: relative;
  background-color: #3a3f51;
  border-radius: 5px;
  width: 109.5px;
  height: 109.5px;
  cursor: pointer;
}

.file-box {
  position: relative;
  background-color: #3a3f51;
  margin: 0 10px;
  border-radius: 5px;
  width: 109.5px;
  height: 109.5px;
}

.cross {
  position: absolute;
  width: 20px;
  height: 20px;
  top: -5px;
  right: -5px;
  cursor: pointer;
}

.file-name {
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.input-box {
  font-size: 17px;
  width: 120px;
  text-align: right;
  color: #ffffff;
  background: #3a3f51;
  border-color: transparent;
}
</style>
